module.exports = __webpack_public_path__ + "img/logo-small.fec6e750.png";